export const hyperpolo = {
  msrp: 34.99,
  infoLink: 'https://www.teamtriton.com/hyperpolo.html',
  items: [
    {
      number: 'HP100',
      hasModel: false,
    },
    {
      number: 'HP101',
      hasModel: false,
    },
    {
      number: 'HP102',
      hasModel: false,
    },
    {
      number: 'HP103',
      hasModel: false,
    },
    {
      number: 'HP104',
      hasModel: false,
    },
    {
      number: 'HP105',
      hasModel: false,
    },
    {
      number: 'HP106',
      hasModel: false,
    },
    {
      number: 'HP107',
      hasModel: false,
    },
    {
      number: 'HP108',
      hasModel: false,
    },
    {
      number: 'HP109',
      hasModel: false,
    },
    {
      number: 'HP110',
      hasModel: false,
    },
    {
      number: 'HP111',
      hasModel: false,
    },
  ],
};
